import MuzikantskaPage from "../../../components/customOrgs/senzacni/MuzikantskaPage";

export default function Bobrovnik() {
    return <MuzikantskaPage />;
}
